export default __webpack_public_path__ + "static/media/share-with-friends.94179e74.png";